import React, { useState, useEffect } from 'react'
import httpClient from '../components/helpers/httpClient'
import './ResetPasswordPage.css'
import { useNavigate, useSearchParams, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from "react-toastify"
import logo_black from "../assets/logos/Logo-Vitruvi-transparant_Wit.png"

function ResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    if (!token) {
      toast.error("Invalid reset link. Please request a new password reset.")
      navigate("/forgotpassword")
    }
  }, [token, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!password) {
      toast.error("Please enter a new password")
      return
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long")
      return
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match")
      return
    }

    if (!token) {
      toast.error("Invalid reset token")
      return
    }

    setLoading(true)

    try {
      const data = { token, new_password: password }
      await httpClient.post(import.meta.env.VITE_API_URL + "/api/admin/reset-password-confirm", data)
      
      setSuccess(true)
      toast.success("Password has been reset successfully")
      
      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate("/")
      }, 2000)
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.error || "Invalid or expired reset token")
        if (error.response.data.error?.includes("expired")) {
          setTimeout(() => {
            navigate("/forgotpassword")
          }, 2000)
        }
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }

    setLoading(false)
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit(event)
    }
  }

  if (!token) {
    return null
  }

  if (success) {
    return (
      <div className="body-resetpassword">
        <img src={logo_black} alt="Vitruvi logo black" />
        <div className="resetpassword-form">
          <h2>Password Reset Successful</h2>
          <p>Your password has been reset successfully. Redirecting to login...</p>
          <div className="resetpassword-links">
            <Link to="/">Go to Login</Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="body-resetpassword">
      <img src={logo_black} alt="Vitruvi logo black" />
      <form className='resetpassword-form' onSubmit={handleSubmit}>
        <h2>Reset Password</h2>
        <p>Enter your new password below.</p>
        <input
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder='NEW PASSWORD'
          onKeyDown={handleEnter}
          type="password"
          disabled={loading}
        />
        <input
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          placeholder='CONFIRM PASSWORD'
          onKeyDown={handleEnter}
          type="password"
          disabled={loading}
        />

        <button type='submit' className='button-resetpassword' disabled={loading}>
          <div className={`${loading ? "hide" : ""}`}>RESET PASSWORD</div>
          {loading && <CircularProgress color="inherit" size={"2.3rem"} />}
        </button>
        <div className='resetpassword-links'>
          <Link to='/'>Back to Login</Link>
        </div>
      </form>
    </div>
  )
}

export default ResetPasswordPage

